import { useCallback, useEffect, useState } from "react";
import { Button, ButtonGroup, Checkbox, DatePicker, Icon, Number, Text, Textarea } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { FaCheck } from "react-icons/fa6";
//#region src/modules/Records/shared/EditableRecordField/components/EditFieldsByType.tsx
function Controls({ onCancel, onComplete }) {
	return /* @__PURE__ */ jsxs(ButtonGroup, {
		subtle: true,
		fullWidth: true,
		children: [/* @__PURE__ */ jsx(Button, {
			onClick: onCancel,
			children: /* @__PURE__ */ jsx(Icon, {
				Icon: IoClose,
				size: "sm"
			})
		}), /* @__PURE__ */ jsx(Button, {
			onClick: onComplete,
			variant: "main",
			children: /* @__PURE__ */ jsx(Icon, {
				Icon: FaCheck,
				color: "main",
				size: "sm"
			})
		})]
	});
}
function EditFieldsByType({ name, onCancel, onComplete, options, type, value }) {
	const [editableValue, setEditableValue] = useState(value);
	const listener = useCallback((event) => {
		if (event.key === "Escape") onCancel();
		else if (event.key === "Enter" && [
			"text",
			"number",
			"datetime"
		].includes(type)) onComplete(editableValue);
	}, [
		editableValue,
		onComplete,
		onCancel,
		type
	]);
	useEffect(() => {
		window.addEventListener("keydown", listener);
		return () => window.removeEventListener("keydown", listener);
	}, [editableValue]);
	if (type === "boolean") return /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs flex min-w-60",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow",
			children: /* @__PURE__ */ jsx(Checkbox, {
				active: !!editableValue,
				name,
				onChangeValue: setEditableValue
			})
		}), /* @__PURE__ */ jsx(Controls, {
			onCancel,
			onComplete: () => onComplete(editableValue)
		})]
	});
	if (type === "number") return /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs flex min-w-60",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow",
			children: /* @__PURE__ */ jsx(Number, {
				onChangeValue: setEditableValue,
				placeholder: "Enter Number",
				value: editableValue
			})
		}), /* @__PURE__ */ jsx(Controls, {
			onCancel,
			onComplete: () => onComplete(editableValue)
		})]
	});
	if (type === "datetime") return /* @__PURE__ */ jsxs("div", {
		className: "min-w-60",
		children: [/* @__PURE__ */ jsx(DatePicker, {
			onChangeValue: setEditableValue,
			timestamp: editableValue
		}), /* @__PURE__ */ jsx("div", {
			className: "m-sm bg-surface rounded",
			children: /* @__PURE__ */ jsx(Controls, {
				onCancel,
				onComplete: () => onComplete(editableValue)
			})
		})]
	});
	if (type === "select") {
		if (Array.isArray(options) && options.length) return /* @__PURE__ */ jsx("div", {
			className: "divide-border max-h-52 divide-y overflow-auto text-sm",
			children: options.map((option) => /* @__PURE__ */ jsx("div", {
				className: "py-xs hover:bg-surface-strong active:bg-surface-subtle cursor-pointer text-center transition-colors",
				onClick: () => onComplete(option.value),
				children: option.label
			}, option.value))
		});
		return /* @__PURE__ */ jsx("div", { children: "No Options" });
	}
	if (type === "textarea") return /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs flex min-w-60",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow",
			children: /* @__PURE__ */ jsx(Textarea, {
				name,
				onChangeValue: setEditableValue,
				value: editableValue
			})
		}), /* @__PURE__ */ jsx(Controls, {
			onCancel,
			onComplete: () => onComplete(editableValue)
		})]
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs flex min-w-60",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow",
			children: /* @__PURE__ */ jsx(Text, {
				name,
				onChangeValue: setEditableValue,
				value: editableValue
			})
		}), /* @__PURE__ */ jsx(Controls, {
			onCancel,
			onComplete: () => onComplete(editableValue)
		})]
	});
}
//#endregion
export { EditFieldsByType };

//# sourceMappingURL=EditFieldsByType.js.map